import { send } from 'server';

export const getPlayerTags = (tagNames) => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get player tags',
    ...tagNames && { tagName: tagNames }
});

export const setPlayerTags = (tags) => send({
    ID: 35544,
    description: 'Set player tags',
    responses: [35545, 35546],
    tags: [...tags]
});

export const fetchUserDetails = (playerFields, networkTypes, networkDataFilters) => send({
    ID: 31082,
    responses: [31083, 31084],
    description: 'Get player info',
    requestType: 'marked',
    returnContactPreferences: true,
    requestedPlayerData: playerFields,
    requestedNetworkTypes: networkTypes,
    playerNetworkDataFilters: networkDataFilters
});

export const getClientIP = () => send({
    ID: 81405,
    description: 'IP address detection',
    responses: [81406, 81407]
});

export const getCountryByGeoIP = ({ casinoName }) => send({
    ID: 35685,
    casino: casinoName,
    description: 'Country by Geo IP detection',
    responses: [35686, 35687]
});

export const getPaymentStatistics = () => send({
    ID: 35209,
    responses: [35210, 35211],
    description: 'Get payment statistics'
});

export const getTransactionHistory = ({
    type,
    status,
    startTime,
    endTime,
    corrections,
    cancellations
}) => send({
    ID: 33026,
    responses: [33027, 33028],
    description: 'Get transaction history',
    type,
    status,
    startTime,
    endTime,
    corrections,
    cancellations
});

export const cancelWithdraw = ({
    transactionCode,
    reason
}) => send({
    ID: 33020,
    responses: [33021, 33022],
    description: 'Cancel withdraw',
    transactionCode,
    reason
});

export const getDetailedTransactionHistory = ({
    cancellations,
    corrections,
    endTime,
    excludePaymentRequests,
    historyRequestSummary,
    pagingRequestParams,
    reason,
    startTime,
    status,
    transactionCode,
    type
}) => send({
    ID: 35610,
    responses: [35611, 35612],
    description: 'Get detailed transaction history',
    transactionCode,
    reason,
    startTime,
    endTime,
    corrections,
    cancellations,
    excludePaymentRequests,
    pagingRequestParams,
    historyRequestSummary,
    status,
    type
});

export const getBalanceHistory = ({
    startDate,
    endDate,
    clientType,
    orderByDate,
    returnSummary,
    transactionGroups,
    ignorePlayerViewConf,
    ignoreStartingEndingBalances,
    pagerRequest
}) => send({
    ID: 32012,
    responses: [32013, 32014],
    description: 'Get balance history',
    startDate,
    endDate,
    clientType,
    orderByDate,
    returnSummary,
    transactionGroups,
    ignorePlayerViewConf,
    ignoreStartingEndingBalances,
    pagerRequest
});

export const getPaymentsConfiguration = casinoName => send({
    ID: 33032,
    responses: [33030, 33031],
    description: 'Get payments configuration',
    casinoname: casinoName
});

export const getURLsRequest = options => send({
    ID: 35844,
    responses: [31032, 31033],
    description: 'Get URLs Request',
    casinoName: options.casinoName,
    clientSkinName: options.clientSkin,
    clientType: options.clientType,
    clientPlatform: options.clientPlatform,
    urlTypeList: options.urlTypeList
});

export const getBalance = subscriptionBalanceTypes => send({
    ID: 31020,
    responses: [31021, 31025],
    description: 'Get Dynamic Balance',
    balanceTypes: subscriptionBalanceTypes
});

export const getTwoFactorConf = ({ casinoName }) => send({
    ID: 35757,
    casino: casinoName,
    description: 'Get Two Factor Conf',
    responses: [35758, 35759]
});
